import React from 'react';
import PropTypes from 'prop-types';

import HospitalizationInfoCards from './cards/hospitalization';
import TakingCareInfoCards from './cards/takingCare';
import TemporaryDisabilityInfoCards from './cards/temporaryDisability';
import DisabilityInfoCards from './cards/disability';
import UnemploymentInfoCards from './cards/unemployment';

const propTypes = {
  nol: PropTypes.shape({
    riskType: PropTypes.string.isRequired,
  }).isRequired,
};
const defaultProps = {};

const NolDetailInfoTab = ({ nol }) => {
  switch (nol?.riskType) {
    case 'HOSPITALIZATION':
      return <HospitalizationInfoCards />;

    case 'TAKING_CARE':
      return <TakingCareInfoCards />;

    case 'TEMPORARY_DISABILITY':
      return <TemporaryDisabilityInfoCards />;

    case 'TOTAL_PERMANENT_DISABILITY':
    case 'PARTIAL_PERMANENT_DISABILITY':
    case 'MINIMAL_PERMANENT_DISABILITY':
      return <DisabilityInfoCards />;

    case 'INVOLUNTARY_UNEMPLOYMENT':
      return <UnemploymentInfoCards />;

    default:
      return null;
  }
};

NolDetailInfoTab.propTypes = propTypes;
NolDetailInfoTab.defaultProps = defaultProps;

export default NolDetailInfoTab;
